<template>
  <base-widget title="Top Links Clicked">
    <base-list
      :items="topLinks"
      :class="`mx-2 ${topLinks.length ? 'mt-n3' : ''}`"
      :show-reload="false"
      :loading="loading"
    >
      <template #loading>
        <base-skeleton
          v-for="n in 5"
          :key="`toplinks_skel_${n}`"
          :opacity="1/n"
          class="px-3 py-3 mx-n3 d-flex align-items-center justify-content-between"
        >
          <div
            class="skeleton__item"
            style="max-width: 400px; margin-top: 0.5rem"
          />
          <div
            class="skeleton__item"
            style="max-width: 25px"
          />
        </base-skeleton>
      </template>
      <template #default="{item, index}">
        <base-cell :class="`pt-3 ${index < topLinks.length - 1 ? 'pb-3' : 'mb-n2'}`">
          <div class="col-11">
            <base-text
              trim
              max-width="900"
              class="black"
              size="m"
            >
              <u><a
                :href="item.url"
                target="_blank"
              >
                {{ item.url }}
              </a></u>
            </base-text>
          </div>
          <div
            class="col-1 ml-auto text-right link"
            @click="onCounterClicked(item)"
          >
            <base-text
              class="mr-2"
              size="md"
            >
              {{ item.count }}
            </base-text>
          </div>
        </base-cell>
      </template>
    </base-list>
    <template v-slot:footer>
      <base-text
        size="s"
        class="text-center link"
      >
        <a @click="$emit('view-all')">View All</a>
      </base-text>
    </template>
  </base-widget>
</template>
<script>
export default {
  name: 'OutReachTopLinksClicked',
  props: {
    topLinks: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCounterClicked({ url, count }) {
      this.$emit('view-detail', { url, count });
    },
  },
};
</script>
<style scoped
  lang="scss">
a {
  cursor: pointer;
}

.link {
  cursor: pointer;
}

.horizontal-divider {
  border-bottom: 0.25px solid #333333cc;
}

.black {
  color: #333;
}

::v-deep .footer {
  margin-top: 20px;
}
</style>
